import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InspectionStateService {

  private canEditInspectionSubject$ = new BehaviorSubject<boolean>(false);
  public canEditInspection$: Observable<boolean> = this.canEditInspectionSubject$.asObservable();
  public getCanEditInspection(): Observable<boolean> {
    return this.canEditInspection$;
  }

  public setCanEditInspection(canEdit: boolean): void {
    this.canEditInspectionSubject$.next(canEdit);
  }

}
